(function () {
	let didomiStatus = null;
	let shopifyPrivacyReady = false;

	window.didomiOnReady = window.didomiOnReady || [];
	window.didomiEventListeners = window.didomiEventListeners || [];

	function waitForShopifyLoadFeatures(timeoutMs, intervalMs) {
	  timeoutMs = timeoutMs || 10000;
	  intervalMs = intervalMs || 50;

	  return new Promise(function (resolve, reject) {
		var start = Date.now();

		function check() {
		  if (
			window.Shopify &&
			typeof window.Shopify.loadFeatures === "function"
		  ) {
			resolve();
			return;
		  }

		  if (Date.now() - start >= timeoutMs) {
			reject(new Error("Timed out waiting for Shopify.loadFeatures"));
			return;
		  }

		  setTimeout(check, intervalMs);
		}

		check();
	  });
	}

	function loadShopifyPrivacyApi() {
	  return waitForShopifyLoadFeatures().then(function () {
		return new Promise(function (resolve, reject) {
		  window.Shopify.loadFeatures(
			[
			  {
				name: "consent-tracking-api",
				version: "0.1"
			  }
			],
			function (error) {
			  if (error) {
				reject(error);
				return;
			  }

			  if (
				!window.Shopify ||
				!window.Shopify.customerPrivacy
			  ) {
				reject(new Error("Shopify customerPrivacy API did not initialize"));
				return;
			  }

			  shopifyPrivacyReady = true;
			  resolve();
			}
		  );
		});
	  });
	}

	function hasAnyEnabledPurpose(status, purposeIds) {
	  const enabledPurposes = new Set(status?.purposes?.consent?.enabled || []);
	  return purposeIds.some(function (id) {
		return enabledPurposes.has(id);
	  });
	}

	function mapDidomiToShopifyConsent(status) {
	  const analyticsPurposes = [
		"measure_ad_performance",
		"measure_content_performance"
	  ];

	  const marketingPurposes = [
		"select_basic_ads",
		"create_ads_profile",
		"select_personalized_ads",
		"market_research"
	  ];

	  const preferencesPurposes = [
		"create_content_profile",
		"select_personalized_content"
	  ];

	  return {
		analytics: hasAnyEnabledPurpose(status, analyticsPurposes),
		marketing: hasAnyEnabledPurpose(status, marketingPurposes),
		preferences: hasAnyEnabledPurpose(status, preferencesPurposes)
	  };
	}

	function logShopifyState(label) {
	  if (!window.Shopify || !window.Shopify.customerPrivacy) return;

	  console.log(label, {
		currentVisitorConsent: window.Shopify.customerPrivacy.currentVisitorConsent(),
		analyticsProcessingAllowed: window.Shopify.customerPrivacy.analyticsProcessingAllowed?.(),
		marketingAllowed: window.Shopify.customerPrivacy.marketingAllowed?.(),
		preferencesProcessingAllowed: window.Shopify.customerPrivacy.preferencesProcessingAllowed?.()
	  });
	}

	function syncConsentToGTM(consent) {
	  if (typeof window.gtag !== "function") return;

	  window.gtag("consent", "update", {
		analytics_storage:        consent.analytics   ? "granted" : "denied",
		ad_storage:               consent.marketing   ? "granted" : "denied",
		ad_user_data:             consent.marketing   ? "granted" : "denied",
		ad_personalization:       consent.marketing   ? "granted" : "denied",
		functionality_storage:    consent.preferences ? "granted" : "denied",
		personalization_storage:  consent.preferences ? "granted" : "denied"
	  });

	  window.dataLayer = window.dataLayer || [];
	  window.dataLayer.push({ event: "didomi_consent_ready" });
	}

	function syncConsentToShopify() {
	  if (!shopifyPrivacyReady) return;
	  if (!didomiStatus) return;
	  if (!window.Shopify || !window.Shopify.customerPrivacy) return;

	  const consent = mapDidomiToShopifyConsent(didomiStatus);

	  syncConsentToGTM(consent);

	  window.Shopify.customerPrivacy.setTrackingConsent(consent, function (result) {
		  console.log("setTrackingConsent result:", result);

		  if (result && result.error) {
			console.error("Shopify setTrackingConsent error:", result.error);
			return;
		  }

		  logShopifyState("Shopify consent updated:");
	  });
	}

	const shopifyApiReady = loadShopifyPrivacyApi();

	shopifyApiReady.then(function () {
	  window.Shopify.customerPrivacy.setTrackingConsent(
		{ analytics: false, marketing: false, preferences: false },
		function () {}
	  );
	});

	const didomiReady = new Promise(function (resolve) {
	  window.didomiOnReady.push(function (Didomi) {
		didomiStatus = Didomi.getUserStatus();
		resolve();
	  });
	});

	Promise.all([didomiReady, shopifyApiReady])
	  .then(function () {
		logShopifyState("Initial Shopify state:");

		syncConsentToShopify();

		window.didomiEventListeners.push({
		  event: "consent.changed",
		  listener: function () {
			if (window.Didomi && typeof window.Didomi.getUserStatus === "function") {
			  didomiStatus = window.Didomi.getUserStatus();
			}

			syncConsentToShopify();
		  }
		});
	  })
	  .catch(function (error) {
		console.error("Consent sync error:", error);
	  });
  })();
